
import React from 'react';

export const EnvelopeIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    mail
  </span>
);